export default function PageHeader({ title, subtitle, children }) {
    return (
        <div className="sticky top-0 z-30 border-b border-[#E2E8F0] bg-white/95 backdrop-blur-sm">
            <div className="px-6 lg:px-8 py-3.5 flex items-center justify-between gap-4">
                <div>
                    <h1
                        className="leading-tight"
                        style={{ fontSize: '20px', fontWeight: 600, color: '#0B1F3A', letterSpacing: '-0.01em' }}
                    >
                        {title}
                    </h1>
                    {subtitle && (
                        <p style={{ fontSize: '13px', color: '#64748B', marginTop: '2px' }}>{subtitle}</p>
                    )}
                </div>
                {children && <div className="flex items-center gap-2 flex-shrink-0">{children}</div>}
            </div>
        </div>
    );
}
